import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from "react-select";
import MultiSelect from "react-multi-select-component";
import * as Cookies from "es-cookie";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import gql from "graphql-tag";
import '../institute_revision_material/_instRevisionMaterial.scss'
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import RevisionMaterialUploadModal from "./RevisionMaterialUploadModal";
import MaterialPDFViewModal from "./MaterialPDFViewModal";


const DELETE_REVISION_MATERIAL = gql`
   mutation($revisionMaterialId:ID){
    deleteRevisionMaterial(revisionMaterialId:$revisionMaterialId)
    }
 `;

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class RevisionMaterialSection extends Component {
    constructor() {
        super();
        this.state = {
            branchSearch: "0",
            branchSearchval: "",
            getExamArr: [],
            examMultiError: "",
            examSearch: "0",
            examSearchVal: "",
            examSelectedvalue: [],
            getClassArr: [],
            classMultiError: "",
            classSelectedvalue: [],
            getSubjectArr: [],
            subjectMultiError: "",
            subjectSelectedvalue: [],
            getChapterArr: [],
            chapterMultiError: "",
            chapterSelectedvalue: [],
            employeeWiseSubjects:[],
            instituteRevisionMaterialData:[],
            materialUploadModal: false,
            materialViewModal: false,
            noDataError:"",
            loader:0,
            individualMaterials:[]
        }
    }

    componentDidMount() {
        let branchData = []
        if (Cookies.get("userlevel") == 3) {
            branchData = this.props.globals.globalBranches.filter((item) => item.id == Cookies.get("branch_id"))
        } else {
            branchData = this.props.globals.globalBranches
        }

        let getExamArr = [];
        let getClassArr = [];
        let getSubjectArr = [];
        let getChapterArr = [];

        if (branchData.length > 0) {
            // Exams selection
            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getExamArr.push(newObj);
            });

            //Class selection

            let selectedExamsValues = getExamArr[0].value;

            let uniqueClasses = [];
            let uniqueSubjects = [{id: 0, subject: "General" }]

            if (selectedExamsValues !=  0) {
                let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(selectedExamsValues)).map((item1) => item1.class_id))].sort();
                uniqueClasses.push(...individualClassValues)
                let employeesdata = this.props.getEmployees.filter((item)=> item.employee_id == Cookies.get("id"))
                
                if(Cookies.get("userlevel") == 3 && employeesdata.length >0){
                    let subjectIdsArray = employeesdata[0].subject_ids.split(",")
                    
                    subjectIdsArray.forEach(subjectId => {
                        const foundSubject = this.props.globals.offlineExamSubjects.filter(item2 => item2.id === +subjectId);
                        if (foundSubject) {
                            foundSubject.map((item)=>{
                                const newObj = {
                                    id: item.id,
                                    subject: item.subject
                                };
                                uniqueSubjects.push(newObj);
                            })
                        }
                    });
                }else{
                    if (this.props.globals.offlineExamSubjects.length > 0){
                        this.props.globals.exams.filter((item) => item.id == parseInt(selectedExamsValues))[0].exam_subjects.map((item1) => {
                            this.props.globals.offlineExamSubjects.map((item2) => {
                                if (item1.subject_id == item2.id) {
                                    uniqueSubjects.push(item2);
                                }
                            })
                        })
                    }
                }
            }
            if (uniqueClasses.length > 0) {
                [...new Set(uniqueClasses)].map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getClassArr.push(newObj);
                });
                if (uniqueSubjects.length > 0) {
                    const uniqueSubjectIds = new Set();

                    uniqueSubjects.forEach((item) => {
                        if (!uniqueSubjectIds.has(item.id)) {
                            uniqueSubjectIds.add(item.id);

                            const newObj = {
                                value: item.id,
                                label: item.subject
                            };

                            getSubjectArr.push(newObj);
                        }
                    });
                }

                if (getSubjectArr.length > 0) {
                    getSubjectArr.map((val) => {
                        let individualSubject = this.props.globals.subjects.find((item1) => +item1.id === val.value);
                        if (individualSubject) {
                            let individualChapterData = individualSubject.chapters;
                            individualChapterData.map((chapter) => {
                                const newObj = {
                                    value: chapter.id,
                                    label: chapter.chapter
                                };
                                getChapterArr.push(newObj);
                            });
                        }
                    });
                }

                this.setState({
                    branchSearchval: {
                        value: branchData[0].id,
                        label: branchData[0].branch_name
                    },
                    branchSearch: branchData[0].id,
                    examSearchVal: {
                        value: getExamArr[0].value,
                        label: getExamArr[0].label
                    },
                    examSearch: getExamArr[0].value,
                    getExamArr: getExamArr,
                    examSelectedvalue: getExamArr,
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSubjectArr: getSubjectArr,
                    subjectSelectedvalue: getSubjectArr,
                    getChapterArr: getChapterArr,
                    chapterSelectedvalue: getChapterArr,
                    examMultiError: "",
                    classMultiError: "",
                    subjectMultiError: ""
                });
            }
            let e = {
                preventDefault: function () {

                }
            }

            setTimeout(() => {
                this.handleSubmit(e)

            }, 100)
        }
    }

    getInstituteRevisionMaterial = async () => {
        const result = await this.props.client.query({
            query: gql`
                query($institute_id:Int!, $branch_id:Int!, $exam_id:Int!, $class_id:String, $subject_id:String, $chapter_id:String){
                    getInstituteRevisionMaterial(institute_id: $institute_id, branch_id:$branch_id, exam_id:$exam_id, class_id:$class_id,subject_id:$subject_id,chapter_id:$chapter_id) {
                        id
                        branch_id
                        branch_name
                        exam_id
                        exam_name
                        class_id
                        class_name
                        subject_id
                        subject_name
                        chapter_id
                        chapter_name
                        file_name
                        file_path
                    }
                }
                `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearch),
                exam_id:parseInt(this.state.examSearch),
                class_id:this.state.classSelectedvalue.map((item) => item.value).toString(),
                subject_id:this.state.subjectSelectedvalue.map((item) => item.value).toString(),
                chapter_id:this.state.chapterSelectedvalue.map((item) => item.value).toString()
            },
            fetchPolicy: 'network-only'
        })
        console.log("ss", result.data.getInstituteRevisionMaterial);
        if (result.data.getInstituteRevisionMaterial.length > 0) {
            let filter_data = result.data.getInstituteRevisionMaterial
            this.setState({
                instituteRevisionMaterialData: filter_data,
                loader: 0
            })

        } else {
            this.setState({ loader: 0, instituteRevisionMaterialData: [], noDataError: "No Material Available" })

        }
    }
    handleMultipleSelectInputChange = (e, name) => {
        if (name == "class") {
            let classSelectedvalue = [];
            let uniqueSubjects = [{id: 0, subject: "General"}];
            let getSubjectArr = [];
            let getChapterArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }
                if (this.state.examSearch != 0) {

                    let employeesdata = this.props.getEmployees.filter((item)=> item.employee_id == Cookies.get("id"))
                
                  if(Cookies.get("userlevel") == 3 && employeesdata.length >0){
                    let subjectIdsArray = employeesdata[0].subject_ids.split(",")
                    
                    subjectIdsArray.forEach(subjectId => {
                        const foundSubject = this.props.globals.offlineExamSubjects.filter(item2 => item2.id === +subjectId);
                        if (foundSubject) {
                            foundSubject.map((item)=>{
                                const newObj = {
                                    id: item.id,
                                    subject: item.subject
                                };
                                uniqueSubjects.push(newObj);
                            })
                        }
                    });
                }else{
                    if (this.props.globals.offlineExamSubjects.length > 0){
                        this.props.globals.exams.filter((item) => item.id == parseInt(this.state.examSearch))[0].exam_subjects.map((item1) => {
                            this.props.globals.offlineExamSubjects.map((item2) => {
                                if (item1.subject_id == item2.id) {
                                    uniqueSubjects.push(item2);
                                }
                            })
                        })
                    }
                }
                }
                if (uniqueSubjects.length > 0) {
                    const uniqueSubjectIds = new Set();

                    uniqueSubjects.forEach((item) => {
                        if (!uniqueSubjectIds.has(item.id)) {
                            uniqueSubjectIds.add(item.id);

                            const newObj = {
                                value: item.id,
                                label: item.subject
                            };
                            getSubjectArr.push(newObj);
                        }
                    });
                }
                if (getSubjectArr.length > 0) {
                    getSubjectArr.map((val) => {
                        let individualSubject = this.props.globals.subjects.find((item1) => +item1.id === val.value);
                        if (individualSubject) {
                            let individualChapterData = []
                            if (this.state.examSearch == "1" || this.state.examSearch == "2") {
                                individualChapterData = this.props.globals.subjects.find((item1) => +item1.id === val.value).chapters.filter((a)=> classSelectedvalue.find((e)=>e.value == a.class));
                            } else {
                                individualChapterData = this.props.globals.subjects.find((item1) => +item1.id === val.value).state_chapters.filter((a)=> classSelectedvalue.find((e)=> parseInt(e.value) == a.class) && this.state.examSearch == a.exam_id);

                            }
                            individualChapterData.map((chapter) => {
                                const newObj = {
                                    value: chapter.id,
                                    label: chapter.chapter
                                };
                                getChapterArr.push(newObj);
                            });
                        }
                    });
                }
                console.log("classchapter", getChapterArr);

                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    getSubjectArr: getSubjectArr,
                    subjectSelectedvalue: getSubjectArr,
                    getChapterArr: getChapterArr,
                    chapterSelectedvalue: getChapterArr,
                    examMultiError: "",
                    classMultiError: "",
                    subjectMultiError: "",
                    instituteRevisionMaterialData: [],
                    noDataError:""
                });
            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    getSubjectArr: [],
                    subjectSelectedvalue: [],
                    getChapterArr: [],
                    chapterMultiError: "",
                    chapterSelectedvalue: [],
                    examMultiError: "",
                    classMultiError: "",
                    subjectMultiError: "",
                    instituteRevisionMaterialData: [],
                    noDataError:""

                });
            }
        }

        if (name == "subject") {
            console.log("eee", e);
            let subjectSelectedvalue = [];
            let getChapterArr = [];
            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const subjectval = e[i];
                    const newObj = {
                        label: subjectval.label,
                        value: subjectval.value,
                    }
                    subjectSelectedvalue.push(newObj);
                }
                if (subjectSelectedvalue.length > 0) {
                    subjectSelectedvalue.map((val) => {

                        if(val.value != "0"){
                            let individualChapterData = []
                            if (this.state.examSearch == "1" || this.state.examSearch == "2") {
                                individualChapterData = this.props.globals.subjects.find((item1) => +item1.id === val.value).chapters.filter((a)=> this.state.classSelectedvalue.find((e)=>e.value == a.class));
                            } else {
                                individualChapterData = this.props.globals.subjects.find((item1) => +item1.id === val.value).state_chapters.filter((a)=> this.state.classSelectedvalue.find((e)=> parseInt(e.value) == a.class) && this.state.examSearch == a.exam_id);

                            }
                            individualChapterData.map((chapter) => {
                                const newObj = {
                                    value: chapter.id,
                                    label: chapter.chapter
                                };
                                getChapterArr.push(newObj);
                            })
                            this.setState({
                                subjectSelectedvalue: subjectSelectedvalue,
                                subjectMultiError: "",
                                getChapterArr: getChapterArr,
                                chapterSelectedvalue: getChapterArr,
                                chapterMultiError: "",
                                instituteRevisionMaterialData: [],
                                noDataError:""
                            });
                        }else{

                            if(subjectSelectedvalue.length > 1){
                                this.setState({
                                    subjectSelectedvalue:subjectSelectedvalue,
                                    subjectMultiError: ""
                                })
                            }else{
                                this.setState({
                                    subjectSelectedvalue:subjectSelectedvalue,
                                    getChapterArr: [],
                                    chapterSelectedvalue: [],
                                    chapterMultiError: "",
                                    subjectMultiError:""
                                })
                            }
                           
                        }
                        
                    });
                }
               
            } else {
                this.setState({
                    subjectSelectedvalue: [],
                    subjectMultiError: "",
                    getChapterArr: [],
                    chapterSelectedvalue: [],
                    chapterMultiError: "",
                    instituteRevisionMaterialData: [],
                    noDataError:""
                })
            }
        }
        if (name == "chapter") {
            let chapterSelectedvalue = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const subjectval = e[i];
                    const newObj = {
                        label: subjectval.label,
                        value: subjectval.value,
                    }
                    chapterSelectedvalue.push(newObj);
                }
                this.setState({
                    chapterSelectedvalue: chapterSelectedvalue,
                    chapterMultiError: "",
                    instituteRevisionMaterialData: [],
                    noDataError:""
                });
            } else {
                this.setState({
                    chapterSelectedvalue: [],
                    chapterMultiError: "",
                    instituteRevisionMaterialData: [],
                    noDataError:""
                })
            }

        }

    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            let branchData = []
            if (Cookies.get("userlevel") == 3) {
                branchData = this.props.globals.globalBranches.filter((item) => item.id == Cookies.get("branch_id"))
                branchData.map((item)=>{
                    const newObj = {
                        value: item.id,
                        label: item.branch_name
                    }
                    getArray.push(newObj);
                 })
            } else {
                this.props.globals.globalBranches.map((stumap) => {
                    const newObj = {
                        value: stumap.id,
                        label: stumap.branch_name
                    }
                    getArray.push(newObj);
                });
            }
        }
        return getArray;
    }

    selecthandleBranch = (name, value) => {

        if (name == "branchSearch") {
            if (value != "0") { 
                let branchSearchData = this.props.globals.globalBranches.filter((a) => a.id == value);
                console.log("branchSearchData", branchSearchData);
                let getExamArr = [];
                let getClassArr = [];
                let getSubjectArr = [];
                let getChapterArr = [];

                if (branchSearchData.length > 0) {
                    // Exams selection
                    let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData[0].id).map((item1) => item1.exam_id))].sort();

                    uniqueExams.map((val) => {
                        let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualExamData.id,
                            label: individualExamData.exam
                        }
                        getExamArr.push(newObj);
                    });
                    //Class selection

                    let selectedExamsValues = getExamArr[0]?.value;


                    let uniqueClasses = [];
                    let uniqueSubjects =[]
                    if(selectedExamsValues != undefined){
                        uniqueSubjects =  [{id: 0, subject: "General"}]
                    }

                    if (selectedExamsValues !=  0) {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData[0].id && item.exam_id == parseInt(selectedExamsValues)).map((item1) => item1.class_id))].sort();
                        uniqueClasses.push(...individualClassValues)
                        let employeesdata = this.props.getEmployees.filter((item)=> item.employee_id == Cookies.get("id"))
            
                        if(Cookies.get("userlevel") == 3 && employeesdata.length >0){
                            let subjectIdsArray = employeesdata[0].subject_ids.split(",")
                            
                            subjectIdsArray.forEach(subjectId => {
                                const foundSubject = this.props.globals.offlineExamSubjects.filter(item2 => item2.id === +subjectId);
                                if (foundSubject) {
                                    foundSubject.map((item)=>{
                                        const newObj = {
                                            id: item.id,
                                            subject: item.subject
                                        };
                                        uniqueSubjects.push(newObj);
                                    })
                                }
                            });
                        }else{
                            if (this.props.globals.offlineExamSubjects.length > 0) {
                                const selectedExam = this.props.globals.exams.find((item) => item.id == parseInt(selectedExamsValues));
                        
                                if (selectedExam) {
                                    const examSubjects = selectedExam.exam_subjects || [];
                        
                                    examSubjects.map((item1) => {
                                        this.props.globals.offlineExamSubjects.map((item2) => {
                                            if (item1.subject_id == item2.id) {
                                                uniqueSubjects.push(item2);
                                            }
                                        });
                                    });
                                }
                            }
                        }
                        }

                    if (uniqueClasses.length > 0) {
                        [...new Set(uniqueClasses)].map((val) => {
                            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualClassData.id,
                                label: individualClassData.class
                            }
                            getClassArr.push(newObj);
                        });

                    }
                    if (uniqueSubjects.length > 0) {
                        const uniqueSubjectIds = new Set();

                        uniqueSubjects.forEach((item) => {
                            if (!uniqueSubjectIds.has(item.id)) {
                                uniqueSubjectIds.add(item.id);

                                const newObj = {
                                    value: item.id,
                                    label: item.subject
                                };

                                getSubjectArr.push(newObj);
                            }
                        });
                    }
                    if (getSubjectArr.length > 0) {
                        getSubjectArr.map((val) => {
                            let individualSubject = this.props.globals.subjects.find((item1) => +item1.id === val.value);
                            if (individualSubject) {
                                let individualChapterData = individualSubject.chapters;
                                individualChapterData.map((chapter) => {
                                    const newObj = {
                                        value: chapter.id,
                                        label: chapter.chapter
                                    };
                                    getChapterArr.push(newObj);
                                });
                            }
                        });
                    }
                    console.log("branchchapter", getChapterArr);

                    this.setState({
                        branchSearchval: {
                            value: branchSearchData[0].id,
                            label: branchSearchData[0].branch_name
                        },
                        branchSearch: branchSearchData.id,
                        branchError: "",
                        examSearchVal: {
                            value: getExamArr[0]?.value,
                            label: getExamArr[0]?.label
                        },
                        examSearch: getExamArr[0]?.value,
                        getExamArr: getExamArr,
                        examSelectedvalue: getExamArr,
                        getClassArr: getClassArr,
                        classSelectedvalue: getClassArr,
                        getSubjectArr: getSubjectArr,
                        subjectSelectedvalue: getSubjectArr,
                        subjectMultiError: "",
                        getChapterArr:getChapterArr,
                        chapterSelectedvalue:getChapterArr,
                        chapterMultiError:"",
                        noDateError: "",
                        examMultiError: "",
                        classMultiError: "",
                        instituteRevisionMaterialData: [],
                        noDataError:""
                    });
                }

            }
        }

        if (name == "examSearch") {
            if (value != "0") {
                let examSearchData = this.props.globals.exams.find((a) => a.id == value);

                let getClassArr = [];
                let getSubjectArr = [];
                let getChapterArr = [];

                let uniqueClasses = [];
                let uniqueSubjects = [{id: 0, subject: "General"}]

                let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(value)).map((item1) => item1.class_id))].sort();
                uniqueClasses.push(...individualClassValues)

                let employeesdata = this.props.getEmployees.filter((item)=> item.employee_id == Cookies.get("id"))
                
                if(Cookies.get("userlevel") == 3 && employeesdata.length >0){
                    let subjectIdsArray = employeesdata[0].subject_ids.split(",")
                    
                    subjectIdsArray.forEach(subjectId => {
                        const foundSubject = this.props.globals.offlineExamSubjects.filter(item2 => item2.id === +subjectId);
                        if (foundSubject) {
                            foundSubject.map((item)=>{
                                const newObj = {
                                    id: item.id,
                                    subject: item.subject
                                };
                                uniqueSubjects.push(newObj);
                            })
                        }
                    });
                }else{
                    if (this.props.globals.offlineExamSubjects.length > 0){
                        this.props.globals.exams.filter((item) => item.id == parseInt(value))[0].exam_subjects.map((item1) => {
                            this.props.globals.offlineExamSubjects.map((item2) => {
                                if (item1.subject_id == item2.id) {
                                    uniqueSubjects.push(item2);
                                }
                            })
                        })
                    }
                }

                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {
                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                }
                if (uniqueSubjects.length > 0) {
                    const uniqueSubjectIds = new Set();

                    uniqueSubjects.forEach((item) => {
                        if (!uniqueSubjectIds.has(item.id)) {
                            uniqueSubjectIds.add(item.id);

                            const newObj = {
                                value: item.id,
                                label: item.subject
                            };

                            getSubjectArr.push(newObj);
                        }
                    });
                }
                console.log("getSubjectArr", getSubjectArr);
                if (getSubjectArr.length > 0) {
                    getSubjectArr.forEach((val) => {
                            let individualChapterData = []
                            if(val.value != "0"){
                            if (value === "1" || value === "2") {
                                individualChapterData = this.props.globals.subjects.find((item1) => +item1.id === val.value).chapters;
                            } else {
                                console.log("else block");
                                individualChapterData = this.props.globals.subjects.find((item1) => +item1.id === val.value).state_chapters.filter((a)=> getClassArr.find((e) => parseInt(e.value) == a.class) && parseInt(a.exam_id) == parseInt(value));
                            }
                        

                            individualChapterData.map((chapter) => {
                                const newObj = {
                                    value: chapter.id,
                                    label: chapter.chapter
                                };
                                getChapterArr.push(newObj);
                            });
                        }
                    });
                }
                console.log("examchapter", getChapterArr);

                this.setState({
                    examSearchVal: {
                        value: examSearchData.id,
                        label: examSearchData.exam
                    },
                    examSearch: examSearchData.id,
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSubjectArr: getSubjectArr,
                    subjectSelectedvalue: getSubjectArr,
                    getChapterArr: getChapterArr,
                    chapterSelectedvalue: getChapterArr,
                    subjectMultiError: "",
                    noDateError: "",
                    examMultiError: "",
                    classMultiError: "",
                    instituteRevisionMaterialData: [],
                    noDataError:""
                });
            }

        }

        this.setState({ [name]: value });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!this.state.examSelectedvalue.length) {
            this.setState({ examMultiError: "Please select exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classMultiError: "Please select class" });
            return ""
        }

        if (!this.state.subjectSelectedvalue.length) {
            this.setState({ subjectMultiError: "Please select subject" });
            return ""
        }
        let subject = this.state.subjectSelectedvalue.filter((a)=> a.value == "0")
        console.log("subject", subject,!this.state.chapterSelectedvalue.length);
        if (!this.state.chapterSelectedvalue.length) {
            if((subject.length && this.state.subjectSelectedvalue.length > 1) || (!subject.length) ){
                this.setState({ chapterMultiError: "Please select chapter" });
                return ""
            }
        }
        this.setState({
            loader: 1
        })

    this.getInstituteRevisionMaterial()
    }

    articlecolumns = [
        {
            dataField: "exam",
            text: "Exam",
            sort: true,
        },
        {
            dataField: "class",
            text: "Class",
            sort: true,
        },
        {
            dataField: "subject",
            text: "Subject",
            sort: true,
        },
        {
            dataField: "chapter",
            text: "Chapter",
            sort: true,
        },
        {
            dataField: "file_name",
            text: "Material Name",
        },
        {
            dataField: "View",
            formatter: this.PdfViewModalFun.bind(this),
            text: "View",
        },
        {
            dataField: "Edit",
            formatter: this.EditFun.bind(this),
            text: "Edit",
        },
        {
            dataField: "Delete",
            formatter: this.DeleteFun.bind(this),
            text: "Delete",
        },
    ];

    PdfViewModalFun(val,row){
        console.log("pdfrow",row);
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ materialViewModal: true, individualMaterials:[row.individualRowData] })}>
                <Button variant="link" name="view" className="text-theme">
                    <i className="fas fa-eye" />
                </Button>
            </div>
        )
    };

    handleDelete = async (id) => {
        if (window.confirm("Do you want Delete this Material")) {
            let revisionMaterialId = id
            this.deleteRevisionMaterial(
                revisionMaterialId
            ).catch(error => {
                console.log("error", error);
                this.setState({
                    submitError: error.graphQLErrors.map(x => x.message),
                    loader: 0
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });
            this.setState({ loader: 1 })
        }
    }
    deleteRevisionMaterial = async (
        revisionMaterialId) => {
        await this.props.deleteRevisionMaterial({
            variables: {
                revisionMaterialId,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.deleteRevisionMaterial) {
                    this.setState({
                        loader: 1,
                        currentStep: 5,
                        submitted: "Deleted Successfully...",
                        spinnerStatus: ""
                    });
                    window.location.reload(false);
                }
            }
        });
    };

    EditFun(val, row) {
        console.log("rrr", row);
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="view" className="text-theme" onClick={() => { this.setState({ materialUploadModal: true, individualMaterials:[row.individualRowData] }) }}>
                    <i className="fas fa-edit" />
                </Button>
            </div>
        </>)
    }

    DeleteFun(val, row) {
        console.log("roww", row.id);
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="view" className="text-theme" onClick={() => { this.handleDelete(row.individualRowData.id) }}>
                    <i className="far fa-trash-alt text-danger" />
                </Button>
            </div>
        </>)
    }

    tableData(data) {     
        let returnData = [];
        data.map((mapData) => {
            const newObj = {
                exam: mapData.exam_name,
                class: mapData.class_name,
                subject: mapData.subject_name,
                chapter: mapData.chapter_name ||  "-",
                file_name: mapData.file_name,
                individualRowData:mapData
            }
            returnData.push(newObj);
        });
        return returnData;
    }
    

    render() {
        console.log("stst", this.state, this.props);
        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let subjectselectall = true;
        let subjectlabelledBy = "Select";
        let subjectdisableSearch = false;

        let chapterselectall = true;
        let chapterlabelledBy = "Select";
        let chapterdisableSearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }


        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "Exam"
        }

        if (this.props.globals.offlineExamSubjects.length > 0) {
            subjectselectall = true;
            subjectdisableSearch = false;
        }
        else {
            subjectdisableSearch = true;
            subjectselectall = false;
            subjectlabelledBy = "Subject"
        }

        if (this.props.globals.subjects.length > 0) {
            chapterselectall = true;
            chapterdisableSearch = false;
        }
        else {
            chapterdisableSearch = true;
            chapterselectall = false;
            chapterlabelledBy = "Chapter"
        }
        return (
            <Container className="">
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h6 className="title text-uppercase mb-0" style={{ marginTop: "30px" }}>Revision Material</h6>
                            <div className='d-flex justify-content-end'>
                                <div style={{ marginTop: "30px" }}>
                                    <button className="upload_btn" onClick={() => { this.setState({ materialUploadModal: true, individualMaterials:[] }) }}>Material Upload</button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Form className='mt-3'>
                    <Form.Row>
                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                            <Form.Label className="font-weight-bold">Branch</Form.Label>
                            <SelectDropDown
                                stateData={this.state.branchSearchval}
                                handleChange={this.selecthandleBranch}
                                name="branchSearch"
                                options={this.dropDownGetValues("branchSearch")}
                                placeholderName={'Branch'}
                                dropdownIndicator={{ DropdownIndicator }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectExam">
                            <Form.Label className="font-weight-bold">Exam</Form.Label>
                            <SelectDropDown
                                stateData={this.state.examSearchVal}
                                handleChange={this.selecthandleBranch}
                                name="examSearch"
                                options={this.state.getExamArr}
                                placeholderName={'Exam'}
                                dropdownIndicator={{ DropdownIndicator }}
                            />
                      
                            <Form.Text className="form-text text-danger">
                                {this.state.examMultiError}
                            </Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                            <Form.Label className="font-weight-bold">Class</Form.Label>
                            <MultiSelect
                                overrideStrings={{
                                    "allItemsAreSelected": "All Classes are selected.",
                                    "selectSomeItems": classlabelledBy
                                }
                                }
                                disableSearch={classdisableSearch}
                                hasSelectAll={classselectall}
                                options={this.state.getClassArr}
                                value={this.state.classSelectedvalue}
                                onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                labelledBy={"class"}
                            />
                            <Form.Text className="form-text text-danger">
                                {this.state.classMultiError}
                            </Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSubject">
                            <Form.Label className="font-weight-bold">Subject</Form.Label>
                            <MultiSelect
                                overrideStrings={{
                                    "allItemsAreSelected": "All Subjects are selected.",
                                    "selectSomeItems": subjectlabelledBy
                                }
                                }
                                disableSearch={subjectdisableSearch}
                                hasSelectAll={subjectselectall}
                                options={this.state.getSubjectArr}
                                value={this.state.subjectSelectedvalue}
                                onChange={(e) => this.handleMultipleSelectInputChange(e, "subject")}
                                labelledBy={"subject"}
                            />
                            <Form.Text className="form-text text-danger">
                                {this.state.subjectMultiError}
                            </Form.Text>
                        </Form.Group>
                        {
                            this.state.getChapterArr.length > 0 || this.state.subjectSelectedvalue.length == 0 ?(
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSubject">
                            <Form.Label className="font-weight-bold">Chapter</Form.Label>
                            <MultiSelect
                                overrideStrings={{
                                    "allItemsAreSelected": "All Chapters are selected.",
                                    "selectSomeItems": chapterlabelledBy
                                }
                                }
                                disableSearch={chapterdisableSearch}
                                hasSelectAll={chapterselectall}
                                options={this.state.getChapterArr}
                                value={this.state.chapterSelectedvalue}
                                onChange={(e) => this.handleMultipleSelectInputChange(e, "chapter")}
                                labelledBy={"chapter"}
                            />
                            <Form.Text className="form-text text-danger">
                                {this.state.chapterMultiError}
                            </Form.Text>
                        </Form.Group>
                            ):""
                        }
                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectStudent">
                            <button className='get_mtrl_btn' onClick={this.handleSubmit}>Get Materials</button>
                        </Form.Group>
                    </Form.Row>
                </Form>
                <Row className="mt-5">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        {
                            this.state.instituteRevisionMaterialData.length > 0 ?
                                (

                                    <CardLessDataTableWithSearch
                                        parentData={this.tableData(this.state.instituteRevisionMaterialData)}
                                        particlecolumns={this.articlecolumns}
                                        name="hostel_attendance"
                                    />

                                ) : (
                                    <Row>
                                        <Col sm={12}>
                                            <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""} >
                                            </div>
                                        </Col>
                                        <Col sm={12}>
                                            {
                                                this.state.noDataError != "" ?
                                                    (
                                                        <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDataError}</h6>
                                                    )
                                                    :
                                                    ("")
                                            }
                                        </Col>
                                    </Row>
                                )
                        }
                    </Col>
                </Row>
                <RevisionMaterialUploadModal
                    globals={this.props.globals}
                    getEmployees={this.props.getEmployees}
                    stateData={this.state}
                    show={this.state.materialUploadModal}
                    onHide={() => this.setState({ materialUploadModal: false })}
                />
                <MaterialPDFViewModal
                    stateData={this.state}
                    show={this.state.materialViewModal}
                    onHide={() => this.setState({ materialViewModal: false })}
                />
            </Container>
        )
    }
}
export default withRouter(withApollo(
    graphql(DELETE_REVISION_MATERIAL, {
        name: "deleteRevisionMaterial"
    })
    (RevisionMaterialSection)));
